import React from 'react';
import PropTypes from 'prop-types';
import { FormControlLabel } from '@material-ui/core';
import { Flex, Switch, Typography } from '@knockrentals/knock-shared-web-v2';
import { makeCss } from '../../../../../../../../knock-design-system';
import HoursTimeSelect from './HoursTimeSelect';
import {
  CLOSED_LABEL,
  OPEN_LABEL,
  TIME_SELECT_FIELDS,
  dayHoursPropType,
} from './constants';

const useCss = makeCss({
  day: {
    minWidth: 96,
    textTransform: 'capitalize',
  },
  toggle: {
    minWidth: 105,
  },
});

const HoursListItem = ({ children, day, dayHours = {}, onChange }) => {
  const css = useCss();
  const { isActive } = dayHours;
  const toggleSwitchLabel = isActive ? OPEN_LABEL : CLOSED_LABEL;

  const handleOpenToggle = (event) => {
    onChange({ isActive: event.target.checked });
  };

  const handleTimeSelectChange = (valueKey) => (value) => {
    onChange({ [valueKey]: value });
  };

  return (
    <Flex alignItems="center" flexWrap="nowrap" gap={16} width="100%">
      <Typography css={css.day} variant="subtitle2">
        {day}
      </Typography>

      <FormControlLabel
        aria-label={`${day} ${toggleSwitchLabel}`}
        css={css.toggle}
        control={
          <Switch
            checked={Boolean(isActive)}
            color="primary"
            onChange={handleOpenToggle}
          />
        }
        label={
          <Typography color="textSecondary" variant="body2">
            {toggleSwitchLabel}
          </Typography>
        }
      />

      <Flex flex={1} gap={16} minWidth={0}>
        {TIME_SELECT_FIELDS.map(({ label, valueKey }) => (
          <HoursTimeSelect
            ariaLabel={`${day} ${label}`}
            disabled={!isActive}
            key={valueKey}
            label={label}
            onChange={handleTimeSelectChange(valueKey)}
            value={dayHours[valueKey]}
          />
        ))}
      </Flex>

      {children}
    </Flex>
  );
};

HoursListItem.propTypes = {
  children: PropTypes.node,
  day: PropTypes.string.isRequired,
  dayHours: dayHoursPropType,
  onChange: PropTypes.func.isRequired,
};

export default HoursListItem;
